module.exports = __webpack_public_path__ + "static/meangirls-8a4f3b2c09e02d4987d5dfee98dfd4e3.gif";